import React, { Fragment } from 'react'
import Prompts from './Prompts'
import SectionHeader from './SectionHeader'
import SummaryBullet from './SummaryBullet'

export default function LifestyleSummary({
  color,
  motivationValues,
  strengthValues,
  qualityValues,
}) {
  return (
    <Fragment>
      <SectionHeader color={color} icon="fas fa-file-alt" str="titles.summary" />
      <Prompts>
        <Prompts.Q str="prose.whatStoodOutToYou" />
        <Prompts.R str="prose.reflect" />
      </Prompts>
      <SummaryBullet
        color={color}
        icon="fas fa-handshake"
        str="prose.lifestyleSummaryMotivations"
        inserts={{ motivations: motivationValues }}
      />
      <SummaryBullet
        color={color}
        icon="fas fa-eye"
        str="prose.lifestyleSummaryVision"
        inserts={{ motivations: motivationValues }}
      />
      <SummaryBullet
        color={color}
        icon="fas fa-heart"
        str="prose.lifestyleSummaryStrengths"
        inserts={{ strengths: strengthValues, qualities: qualityValues }}
      />
      <SummaryBullet
        color={color}
        icon="fas fa-clock"
        str="prose.lifestyleSummaryRoutine"
        inserts={{ strengths: strengthValues }}
      />
      <SummaryBullet
        color={color}
        icon="fas fa-prescription-bottle-alt"
        str="prose.lifestyleSummaryMedication"
      />
      <SummaryBullet
        color={color}
        icon="fas fa-users"
        str="prose.lifestyleSummaryFamily"
      />
      <SummaryBullet
        color={color}
        icon="fas fa-leaf"
        str="prose.lifestyleSummaryLifestyle"
      />
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/LifestyleSummary.js